/* eslint-disable import/no-unresolved */
import React from 'react';
import signet1SVG from 'assets/resources/pages/about-us/signet1.svg';
import signet2SVG from 'assets/resources/pages/about-us/signet2.svg';
import signet3SVG from 'assets/resources/pages/about-us/signet3.svg';
import ImgHTML from '../ImgHTML';

const AboutUsLogo = () => {
  return (
    <div className="container">
      <div className="logotype-beam">
        <h3>Logo origins</h3>
        <div className="logotypes">
          <div className="draft">
            <ImgHTML src={signet1SVG} alt="Ulam Spiral" />
            <div className="sig">Ulam Spiral</div>
          </div>
          <div className="draft v-center">
            <ImgHTML src={signet2SVG} className="sm" alt="U Letter" />
            <div className="sig">&quot;U&quot; Letter</div>
            <div className="rule left">+</div>
            <div className="rule right">=</div>
          </div>
          <div className="draft">
            <ImgHTML src={signet3SVG} className="sm" alt="Ulam Labs Signet" />
            <div className="sig">Ulam Labs Signet</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsLogo;
